// TextAreaInput.js
import React from 'react';

const TextAreaInput = ({ label, name, value, onChange, required, placeholder }) => {
    return (
        <div className="form-group">
            <label>{label} {required && <span>*</span>}</label>
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                placeholder={placeholder}
                className="form-input"
            />
        </div>
    );
};

export default TextAreaInput;
